module.exports = __webpack_public_path__ + "static/media/droneIcon.79a99114.svg";